module.exports = __webpack_public_path__ + "static/assets/6cde813ee10f97049711a5c7b3f887bb.svg";